import { render, staticRenderFns } from "./ResumationTextArea.vue?vue&type=template&id=6360ba80&"
import script from "./ResumationTextArea.vue?vue&type=script&lang=js&"
export * from "./ResumationTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports